import { render, staticRenderFns } from "./NewContactAndConversationForm.vue?vue&type=template&id=1fb4d27b&scoped=true&"
import script from "./NewContactAndConversationForm.vue?vue&type=script&lang=js&"
export * from "./NewContactAndConversationForm.vue?vue&type=script&lang=js&"
import style0 from "./NewContactAndConversationForm.vue?vue&type=style&index=0&id=1fb4d27b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4d27b",
  null
  
)

export default component.exports